
import { mapActions } from 'vuex'

export default {
  name: 'VFooter',
  methods: {
    ...mapActions({
      resetCustomer: 'customer/resetState'
    }),
    async logout () {
      this.$logout()
      await this.resetCustomer()

      // redirect to https://www.credimaxx.de/login/ after logout
      window.location.href = 'https://www.credimaxx.de/login/'
    }
  }
}
